import { put, takeLatest, fetch, apply } from '@ers/helpers/redux/sagaEffects';
import { FileHelper } from '@ers/helpers/';

import useUserManager from '@ers/authorization/userManager';
import ApiFactory from '@ers/api/ApiFactory';
import config from '@ers/config';
import { addSuccess, addInfo } from '../toasts/toasts.actions';
import { ActionTypes, exportUserDataCompleted, fetchPrivacyConsentsCompleted, fetchActiveSessionsCompleted, logoutFromSessionCompleted, fetchNotificationsCompleted } from './Settings.actions';
import AppApi from '../App.api';
import AppAuthApi from '../App.auth.api';


function* exportUserData(api) {
    yield put(addInfo('Trwa przygotowanie pliku do pobrania', 5));
    const exportedDataResponse = yield fetch(api, api.exportUserData);
    if (!(exportedDataResponse.error)) {
        FileHelper.downloadFile(exportedDataResponse.data);
    }

    yield put(exportUserDataCompleted({ payload: { exportedData: exportedDataResponse.data } }));
}

function* getPrivacyConsents(api) {
    const consentsResponse = yield fetch(api, api.fetchConsents);
    if (!(consentsResponse.error)) {
        yield put(fetchPrivacyConsentsCompleted({ payload: { consents: consentsResponse.data } }));
    }
}

function* updatePrivacyConsent(api, action) {
    const { consentId, isChecked } = action.payload;
    const response = yield fetch(api, api.updatePrivacyConsent, [consentId, isChecked]);
    if (!(response.error) && Boolean(response.data)) {
        yield put(addSuccess('Ustawienia prywatności zostały zmienione', 5));
    }
}


function* deleteUserAccount(api) {
    yield fetch(api, api.deleteUserAccount);
    const userManager = useUserManager();
    yield userManager.signoutRedirect({ post_logout_redirect_uri: config.authorization.post_account_delete_redirect_uri });
}

function* getActiveSessions(api) {
    const sessionResponse = yield fetch(api, api.fetchActiveSessions);
    if (!(sessionResponse.error) && Boolean(sessionResponse.data)) {
        yield put(fetchActiveSessionsCompleted({ payload: { sessions: sessionResponse.data } }));
    }
}

function* deleteSession(api, action) {
    const { sessionId } = action.payload;
    const logoutResponse = yield fetch(api, api.logoutFromSession, [sessionId]);
    if (!(logoutResponse.error)) {
        yield put(logoutFromSessionCompleted(sessionId));
        yield put(addSuccess('Wylogowano z urządzenia', 5));
    }
}

function* getNotifications(api) {
    const notificationsResponse = yield fetch(api, api.fetchNotifications);
    if (!(notificationsResponse.error)) {
        yield put(fetchNotificationsCompleted({ payload: { notifications: notificationsResponse.data } }));
    }
}

function* updateNewApplicationEmailNotification(api, action) {
    const { notificationId, isChecked } = action.payload;
    const response = yield fetch(api, api.updateNewApplicationEmailNotification, [notificationId, isChecked]);
    if (!(response.error) && Boolean(response.data)) {
        yield put(addSuccess('Ustawienia powiadomień zostały zmienione', 5));
    }
}

export default function* settingsSaga() {
    const apiFactory = new ApiFactory();
    const api = yield apply(apiFactory, apiFactory.create);
    const authApi = yield apply(apiFactory, apiFactory.createAuth);
    const appApi = new AppApi(api);
    const appAuthApi = new AppAuthApi(authApi);
    yield takeLatest(ActionTypes.exportUserData, exportUserData, appApi);
    yield takeLatest(ActionTypes.fetchPrivacyConsents, getPrivacyConsents, appApi);
    yield takeLatest(ActionTypes.updatePrivacyConsent, updatePrivacyConsent, appApi);
    yield takeLatest(ActionTypes.deleteUserAccount, deleteUserAccount, appApi);
    yield takeLatest(ActionTypes.fetchActiveSessions, getActiveSessions, appAuthApi);
    yield takeLatest(ActionTypes.logoutFromSession, deleteSession, appAuthApi);
    yield takeLatest(ActionTypes.fetchNotifications, getNotifications, appApi);
    yield takeLatest(ActionTypes.updateNewApplicationEmailNotification, updateNewApplicationEmailNotification, appApi);
}
